import React, {useCallback} from 'react';
import { Flex, Button, Text } from '@pancakeswap/uikit';

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const handleFirstPage = () => onPageChange(1);
  const handlePreviousPage = () => onPageChange(currentPage - 1);
  const handleNextPage = () => onPageChange(currentPage + 1);
  const handleLastPage = () => onPageChange(totalPages);

  return (
    <Flex
      width="90%"
      flexDirection="column"
      padding="12px"
      style={{ backdropFilter: 'blur(1px)' }}
      alignSelf="center"
      alignItems="center"
      justifyContent="center"
      borderRadius="24px"
    >
      <Flex justifyContent="center">
        <Button
          marginX="2px"
          minWidth="50px"
          scale="pawg"
          onClick={handleFirstPage}
          disabled={currentPage === 1}
          variant="secondarytrans"
        >
          &#60;&#60;
        </Button>
        <Button
          marginX="2px"
          minWidth="100px"
          scale="pawg"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          variant="secondarytrans"
        >
          Previous
        </Button>
        <Button
          marginX="2px"
          variant="secondarytrans"
          scale="pawg"
          minWidth="100px"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
        <Button
          marginX="2px"
          minWidth="50px"
          scale="pawg"
          onClick={handleLastPage}
          disabled={currentPage === totalPages}
          variant="secondarytrans"
        >
          &#62;&#62;
        </Button>
      </Flex>
      <Text
        fontWeight="600"
        fontSize="14px"
        textTransform="uppercase"
        color="secondary"
      >{`${currentPage} of ${totalPages}`}</Text>
    </Flex>
  );
};

export default React.memo(PaginationControls);